import * as userActions from '../user/actions';
import * as unitedCardPNDActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const unitedCardPNDReducer = (state = initialState, action) => {
    switch (action.type) {
        case unitedCardPNDActions.SET_UNITED_CARD_PND_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case unitedCardPNDActions.SET_UNITED_CARD_PND_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case unitedCardPNDActions.SET_UNITED_CARD_PND:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case unitedCardPNDActions.ABORT_UNITED_CARD_PND_REQUEST:
            return initialState;

        case unitedCardPNDActions.CLEAN_UNITED_CARD_PND:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/unitedCardPND/reducer.js